if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends QuickAddModal {
      constructor() {
        super();
        this.modal = null;
        this.setupQuickAddButton();
        this.setupEventListeners();
      }

      setupQuickAddButton() {
        // Create quick add button
        const button = document.createElement('button');
        button.classList.add('quick-add-button');
        button.innerHTML = `
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M8 16L12 12M12 12L16 16M12 12L8 8M12 12L16 8" stroke="currentColor" stroke-width="2"/>
          </svg>
          Achat rapide
        `;
        this.appendChild(button);
      }

      setupEventListeners() {
        this.querySelector('.quick-add-button').addEventListener('click', (event) => {
          event.preventDefault();
          this.openProductModal();
        });
      }

      async openProductModal() {
        const productUrl = `${window.location.origin}/products/${this.dataset.productHandle}`;
        const response = await fetch(`${productUrl}?view=quick-add`);
        const html = await response.text();

        // Create and show modal
        this.modal = document.createElement('div');
        this.modal.classList.add('quick-add-modal');
        this.modal.innerHTML = `
          <div class="quick-add-modal__overlay"></div>
          <div class="quick-add-modal__content">
            <button class="quick-add-modal__close">×</button>
            <div class="quick-add-modal__body">
              ${html}
            </div>
          </div>
        `;

        document.body.appendChild(this.modal);
        
        // Add event listeners for close button and overlay
        this.modal.querySelector('.quick-add-modal__close').addEventListener('click', () => this.closeModal());
        this.modal.querySelector('.quick-add-modal__overlay').addEventListener('click', () => this.closeModal());
      }

      closeModal() {
        if (this.modal) {
          this.modal.remove();
          this.modal = null;
        }
      }
    }
  );
}